














import { defineComponent, PropType } from '@nuxtjs/composition-api';

import { Block, Mark } from '../../constants';
import { MarkNode, TextNode } from '../../types';
import { SbLink, SbText } from '../marks';
import SbBreak from './Break.vue';
import SbImage from './Image/Image.vue';

export default defineComponent({
  name: 'SbParagraph',
  components: {
    SbBreak,
    SbText,
    SbLink,
    SbImage,
  },
  props: {
    content: {
      type: Array as PropType<TextNode[]>,
      required: true,
    },
  },
  data() {
    return {
      Block,
      Mark,
    };
  },
  methods: {
    isLink(marks: MarkNode[]) {
      return marks && marks.findIndex((mark) => mark.type === this.Mark.LINK) > -1;
    },
    getAttrs(marks: MarkNode[]) {
      const linkMark = marks.find((mark) => mark.type === this.Mark.LINK);
      if (linkMark) return linkMark.attrs;
      else return {};
    },
  },
});
